import { useEffect } from 'react'

export const useViewportBottomLeft = (): void => {
  useEffect(() => {
    // This class is used to hide the accessibility and chat buttons when the sticky bar is open.
    document.body.classList.add('free-viewport-bottom-left')

    return () => {
      document.body.classList.remove('free-viewport-bottom-left')
    }
  }, [])
}
